import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const routes = [
  // Public marketing landing — the page Google indexes and the entry point
  // for logged-out visitors. Authenticated users are bounced to the app
  // (see the guard below); the installed PWA opens at /rooster directly.
  { path: '/',         name: 'landing',  component: () => import('@/views/LandingView.vue'),  meta: { public: true } },
  { path: '/login',    name: 'login',    component: () => import('@/views/LoginView.vue'),    meta: { public: true } },
  { path: '/register', name: 'register', component: () => import('@/views/RegisterView.vue'), meta: { public: true } },
  { path: '/wachtwoord-vergeten', name: 'forgot-password', component: () => import('@/views/ForgotPasswordView.vue'), meta: { public: true } },
  { path: '/wachtwoord-reset',    name: 'reset-password',  component: () => import('@/views/ResetPasswordView.vue'),  meta: { public: true } },
  { path: '/verifieer',           name: 'verify-email',    component: () => import('@/views/VerifyEmailView.vue'),    meta: { public: true } },
  { path: '/auth/google/callback', name: 'google-callback', component: () => import('@/views/GoogleCallbackView.vue'), meta: { public: true } },
  { path: '/rooster',  name: 'schedule', component: () => import('@/views/ScheduleView.vue') },
  { path: '/event/:id', name: 'event-detail', component: () => import('@/views/EventDetailView.vue'), props: true },
  { path: '/lia',      name: 'lia',      component: () => import('@/views/LiaView.vue') },
  { path: '/feed',     name: 'feed',     component: () => import('@/views/FeedView.vue') },
  { path: '/tips',     name: 'tips',     component: () => import('@/views/TipsView.vue') },
  { path: '/magister', name: 'magister', component: () => import('@/views/MagisterView.vue') },
  { path: '/profiel',  name: 'profile',  component: () => import('@/views/ProfileView.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to: RouteLocationNormalized) => {
  const auth = useAuthStore();
  // Logged-in visitors have no use for the marketing landing — drop them
  // straight into the app instead of the public homepage.
  if (to.name === 'landing' && auth.isAuthenticated) return { name: 'schedule' };
  if (to.meta.public) return true;
  if (!auth.isAuthenticated) return { name: 'login', query: { next: to.fullPath } };
  return true;
});
